export type CheckoutFastFlowState = "idle" | "deciding" | "running" | "success" | "skip" | "fail";

export type CheckoutFastFlowAction =
  | { type: "READY" }
  | { type: "RUN" }
  | { type: "COMPLETE"; result: Extract<CheckoutFastFlowState, "success" | "skip" | "fail"> };
